import React, {Component} from 'react';
import {
    Route,
    NavLink,
    Link
} from "react-router-dom";
import Paper from '@material-ui/core/Paper'
import Dropzone from 'react-dropzone'
import {database} from '../firebaseconfig.js'
import FieldTextArea from '@atlaskit/field-text-area'
import AsyncButton from '../components/AsyncButton'
import {functions, storage} from "../firebaseconfig";
var qs = require('qs');



export default class DriveOAuth extends React.Component {


    componentDidMount() {
        const uploadfiles = functions.httpsCallable('uploadfiles');
        let query = qs.parse(this.props.location.search)
        console.log(query)
        uploadfiles({"code": query['code'], "course_id": query["?state"]}).then(function(result) {
            const session = result.data
            console.log(session)
        });
    }

    render() {
        return (
            <div className="container">
                .. Uploading files to your Google Drive
            </div>
        )
    }
}




// WEBPACK FOOTER //
// ./src/StudentApp/DriveOAuth.js